import React, { useState } from "react"
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Box from "@material-ui/core/Box";

export const OnClickPopoverCell = ({ data }: { data: string[] }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const id = open ? 'onclick-popover' : undefined;

    if (data.length > 1) {
        return (
            <Box width="100%">
                <Typography
                    style={{ cursor: 'pointer'}}
                    onClick={handleClick}
                >
                <MoreHorizIcon />
                </Typography>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    onClose={handleClose}
                >
                <List>
                    {data.map(item => 
                        <ListItem>
                            <ListItemText primary={item} />
                        </ListItem>
                    )}
                </List>
                </Popover>
            </Box>
        )
    }
    else {
        return(<span>{data[0]}</span>)
    }
}